import React from 'react';
import { Form, Button, FormField, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withPopup } from '../../lib/popup';
import { Popup } from '../../lib/custom-ui';
import { FunctionTypesMap } from '../../constants/Enums';
import api from '../../api';

const FunctionPopup = React.memo(({ functions, id, onUpdate, onClose }) => {
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  const handleCheckboxChange = (e, { name }) => {
    if (selectedOptions.includes(name)) {
      setSelectedOptions(selectedOptions.filter((option) => option !== name));
    } else {
      setSelectedOptions([...selectedOptions, name]);
    }
  };

  const handleSubmit = () => {
    api
      .updateUserFunction({
        id,
        functions: selectedOptions,
      })
      .then(() => {
        onUpdate();
        onClose();
      });
  };

  React.useEffect(() => {
    if (functions && functions.length) {
      setSelectedOptions(functions.map((func) => func.type));
    }
  }, [functions]);
  return (
    <>
      <Popup.Header wide>开放功能</Popup.Header>
      <Popup.Content>
        <Form onSubmit={handleSubmit}>
          {[...FunctionTypesMap.entries()].map(([key, value]) => (
            <FormField key={key}>
              <Checkbox
                label={value}
                name={key}
                checked={selectedOptions.includes(key)}
                onChange={handleCheckboxChange}
              />
            </FormField>
          ))}
          <Button type="submit" positive>
            提交
          </Button>
        </Form>
      </Popup.Content>
    </>
  );
});

FunctionPopup.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  functions: PropTypes.arrayOf,
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
FunctionPopup.defaultProps = {
  functions: [],
};
export default withPopup(FunctionPopup);
